import { TableItem } from './TableItem';

export default TableItem;